module.exports = __webpack_public_path__ + "pc/img/brand01.58f38c9a.png";